/**
 * PATH: apps/qa/src/pages/ai-insights/api.ts
 * PURPOSE: API functions for AI insights feature
 */

import api from '@/lib/api'
import type { EvidenceAnalysis, ReadinessCheck, TemplateSuggestion } from './types'

export async function analyzeEvidence(inspectionId: string): Promise<EvidenceAnalysis> {
  const response = await api().post('/qa/ai/analyze-evidence/', {
    inspection_id: inspectionId,
  })
  return response.data
}

export async function checkReadiness(inspectionId: string): Promise<ReadinessCheck> {
  const response = await api().post('/qa/ai/check-readiness/', {
    inspection_id: inspectionId,
  })
  return response.data
}

export async function suggestItems(
  templateId: string,
  sectionName: string
): Promise<{ suggestions: TemplateSuggestion[] }> {
  const response = await api().post('/qa/ai/suggest-items/', {
    template_id: templateId,
    section_name: sectionName,
  })
  return response.data
}
